const caseStudies = [
  {
    title: "日系金融機関に勤務",
    tags: ["金融", "国際業務", "中間管理職"],
    category: "business",
    details: {
      recipient: "35~55歳/国際業務・中間管理職",
      format: "プライベートレッスン",
      challenges: [
        "国際的な金融規制やポリシーに関する会議やディスカッションで、専門的な内容を英語で正確に理解し、効果的に発言するのが困難。",
        "複雑な金融商品やサービスについて、英語での説明が不十分で、クライアントや海外のステークホルダーに対する影響力が低い。",
        "英語でのリスク管理報告、投資分析報告、金融市場のトレンド分析が求められるが、専門用語の使用に自信がない。"
      ],
      needs: [
        "金融市場の動向、規制変更、リスク管理に関する最新情報を英語で迅速にキャッチアップし、それを自社の戦略に反映させる能力を高めたい。",
        "金融専門用語や表現を正確に使いこなし、国際的な会議やプレゼンテーションでの説得力を向上させること。",
        "多国籍なチームとのプロジェクトでリーダーシップをとり、英語で効果的なコミュニケーションを行う能力を身につけたい。"
      ],
      results: [
        "国際的な金融会議でのプレゼンテーションを通じて、自信を持って自社の立場を代表し、意見を交わす。",
        "英語での金融分析レポート作成や、投資提案書の作成スキルを向上させ、国際的なクライアントへの影響力を強化。",
        "グローバルなプロジェクトのリーダーシップを担い、英語での交渉や戦略的意思決定において中心的役割を果たす。"
      ],
    },
  },
  {
    title: "外資系製薬会社に勤務",
    tags: ["製薬", "研究", "開発"],
    category: "business",
    details: {
      recipient: "35~55歳/研究・開発職",
      format: "プライベートレッスン",
      challenges: [
        "研究データや臨床試験の結果を英語で効果的にプレゼンテーションする能力に欠けており、国際的な学会や会議で自信を持って発表ができない。",
        "新しい研究論文や専門文献を読むことはできるが、それを自らの言葉で英語で説明することが困難。",
        "英語でのリアルタイムのディスカッションや意思疎通がスムーズに行えず、国際的なプロジェクトチームでの貢献が限定的。"
      ],
      needs: [
        "専門的な医学用語や製薬業界特有の表現を正確に使用し、クリアにコミュニケーションできる英語能力の向上。",
        "グローバルな研究チームや医療専門家との協働時に必要とされる、専門的な英語コミュニケーションスキルを習得。",
        "英語での論文執筆や学術発表のスキルを向上させることで、国際的な認知とキャリアの発展を目指す。"
      ],
      results: [
        "国際的な学術会議で、研究成果を自信を持って英語でプレゼンテーションし、聴衆からの質問にも対応。",
        "英語での科学的ディスカッションにおいて、自らの研究アイディアや意見を効果的に表現し、同僚や専門家からの高い評価を獲得。",
        "グローバルな研究チーム内でリーダーシップを発揮し、国際的な共同研究プロジェクトを成功させることができる能力を習得。"
      ],
    },
  },
  {
    title: "インターナショナルスクールの入試対策",
    tags: ["インターナショナルスクール", "ボーディングスクール"],
    category: "international school",
    details: {
      recipient: "小学5年生",
      format: "プライベートレッスン",
      challenges: [
        "算数の試験には合格したが、英作文や英語面接の対策が全くできていない。",
        "英語はアルファベットが書ける程度で、英会話アプリを使って英語を使っている程度。"
      ],
      needs: [
        "英作文や面接で必要な英語表現や語彙を強化し、スムーズに受け答えできる自信をつけたい。",
        "インターナショナルスクールで求められる英語力を体系的に学び、入試に合格できるようにしたい。"
      ],
      results: [
        "英作文の構造や表現方法を習得し、入試で課題となる作文試験に合格。",
        "英語面接での受け答えがスムーズになり、ハロウインターナショナルスクール安比校に無事合格。"
      ],
    },
  },
  {
    title: "IELTS対策 (5.0以上)",
    tags: ["帰国子女", "海外大学", "IELTS"],
    category: "ielts",
    details: {
      recipient: "高校1年生",
      format: "プライベートレッスン",
      challenges: [
        "オーストラリアの高校に通っているが、将来の大学進学を見据えてIELTS対策を行いたい。",
        "現在は平均してOverallで4.0ほどのスコアであるが、安定して5.0以上を取得できるようになりたい。"
      ],
      needs: [
        "リスニングやリーディングの基礎スキルを強化し、SpeakingやWritingセクションでのスコアを伸ばしたい。",
        "IELTSテストでの時間管理や問題解決のコツを習得し、安定したスコアを目指す。"
      ],
      results: [
        "IELTS Overall 5.5を達成し、希望する大学の出願条件を満たす。",
        "テスト対策を通じて英語力全般が向上し、学校生活での自信が増した。"
      ],
    },
  },
  {
    title: "中学校で英語教諭として勤務",
    tags: ["教育者"],
    category: "general",
    details: {
      recipient: "25~30歳/英語教諭",
      format: "プライベートレッスン",
      challenges: [
        "中学校で英語を教えており、綺麗な発音やより正しい英語の知識を深めたい。"
      ],
      needs: [
        "生徒に自信を持って教えるため、発音や表現の正確さを高めたい。",
        "授業で使用する英語力を総合的に向上させたい。"
      ],
      results: [
        "発音の精度が上がり、生徒からの信頼度が向上。",
        "授業の内容がより分かりやすくなり、指導スキルの評価が上昇。"
      ],
    },
  },
  {
    title: "海外のロースクール対策",
    tags: ["海外大学", "IELTS", "法曹"],
    category: "ielts",
    details: {
      recipient: "35~49歳/弁護士",
      format: "プライベートレッスン",
      challenges: [
        "現在は英検1級とIELTS Overall6.5を保有しているが、将来海外のロースクールを目指しており、そのためにIELTS7.0以上を獲得したい。"
      ],
      needs: [
        "IELTS WritingやSpeakingでの表現力を向上させ、ハイレベルな英語での論述能力を身につけたい。",
        "ロースクール出願に必要なスコアを取得し、英語での法的議論や学術的文章作成能力を向上。"
      ],
      results: [
        "IELTS Overall 7.5を取得し、希望するロースクールへの出願が可能に。",
        "法的議論やエッセイ作成における英語能力が向上し、面接対策にも自信を持てるようになった。"
      ],
    },
  },
  {
    title: "海外の友人との話すための英語習得",
    tags: ["日常英会話", "海外旅行"],
    category: "general",
    details: {
      recipient: "50~65歳",
      format: "プライベートレッスン",
      challenges: [
        "イギリスがとても好きで、趣味としてイギリス英語を習得したい。",
        "海外旅行でイギリスに訪れた際に現地の友人と深いコミュニケーションを取りたい。"
      ],
      needs: [
        "イギリス英語の発音や独特の表現を習得し、旅行中や友人との会話をより楽しみたい。",
        "趣味としての英語学習を楽しみながら、日常的な会話力を向上させたい。"
      ],
      results: [
        "イギリス英語の特徴的な発音や表現を使いこなせるようになり、現地の友人との会話が弾む。",
        "旅行中にも地元の人々との交流をより深く楽しむことができた。"
      ],
    },
  },
  {
    title: "IELTS対策 (7.0以上)",
    tags: ["海外大学", "IELTS"],
    category: "ielts",
    details: {
      recipient: "35~49歳/商社勤務",
      format: "プライベートレッスン",
      challenges: [
        "商社で海外には合計で5年以上の駐在経験がある。",
        "将来は海外でMBAを考えており、IELTSで7.0以上を獲得したい。"
      ],
      needs: [
        "IELTS WritingとSpeakingを中心にスコアアップを目指し、7.0以上のスコアを安定して取得したい。",
        "MBA出願に求められる高度な英語スキルを磨きたい。"
      ],
      results: [
        "IELTS Overall 7.5を達成し、MBA出願資格を満たす。",
        "テスト対策を通じて英語での論理的思考力やプレゼンテーション能力が向上。"
      ],
    },
  },
  {
    title: "帰国後の英語力維持",
    tags: ["帰国子女", "海外大学"],
    category: "international school",
    details: {
      recipient: "小学6年生",
      format: "プライベートレッスン",
      challenges: [
        "小学校を海外のインターで過ごし、小学校6年生で帰国。",
        "英検の準一級は取得済み。",
        "帰国してから英語力が落ちないようにし、将来は海外大学への進学も見据えて対策を行いたい。"
      ],
      needs: [
        "英語のアウトプット機会を増やし、会話力やライティングスキルを維持・向上させたい。",
        "海外大学進学を見据えたスキルアップと試験対策を継続したい。"
      ],
      results: [
        "英語でのスピーキング力やライティング力が向上し、帰国後もインターの学びを活かせる。",
        "帰国後も英語力が維持され、海外大学への進学も視野に入る。"
      ],
    },
  }
];

export default caseStudies;